<!--常见的tab
-->
<template>
	<div class="flex-data" :style="dataStyle">
		<div :key='i' class='item-class' :style='getItemStyle(item)' v-for="(item,i) in dataList" @click='clickItem(item)'>
			<img :src='getImgIcon(item)' />
			<span>{{getItemLabel(item)}}</span>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			dataStyle: {
				type: Object,
				default: () => {
					return {
						'width': '100%',
						'heigth': '100%'
					}
				}
			},
			dataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			isSame: {
				type: Function,
				default: (a, b) => {
					return a == b
				}
			},
			getItemLabel: {
				type: Function,
				default: (a) => {
					return a
				}
			},
			defaultList: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				selectList: [],
				show: false
			}
		},
		created() {},
		mounted() {
			if (!isempty(this.tabList)) {
				this.nowTab = this.tabList[this.tabList.length-1]
			}
			this.setDefaultList()
		},
		destroyed() {},
		computed: {
			closeImg() {
				return resourcesStore.getters.getResourcesByName('wedoButton/close.png')
			},
			getImgIcon() {
				return item => {
					if (this.selectList.includes(item)) {
						return resourcesStore.getters.getResourcesByName('checkBox/checked.png')
					} else {
						return resourcesStore.getters.getResourcesByName('checkBox/unchecked.png')
					}
				}
			},
			getItemStyle() {
				return item => {
					if (this.selectList.includes(item)) {
						return {
							'color': '#5599FF !important',
							// 'background':'#5599FF',
							'border': '1px solid #5599FF !important',
						}
					} else {
						return {
							'color': 'black !important',
						}
					}
				}
			}
		},
		watch: {
			defaultList(nv, ov) {
				this.setDefaultList()
			}
		},
		methods: {
			setDefaultList() {
				this.selectList = []
				//设置默认勾选的list
				if (!isempty(this.defaultList)) {
					var temp = []
					this.selectList = []
					temp = this.defaultList.filter(i => {
						return i != ''
					})
					this.selectList.addAll(temp)
					this.$emit('checkItem', this.selectList)
				}
			},
			clickItem(item) {
				var index = -1
				for (var i = 0, len = this.selectList.length; i < len; i++) {
					var temp = this.selectList[i]
					if (this.isSame(item, temp)) {
						index = i
						break
					}
				}
				if (index > -1) {
					this.selectList.splice(index, 1)
				} else {
					this.selectList.push(item)
				}
				this.$emit('checkItem', this.selectList)
			}
		}
	}
</script>

<style scoped>
	.flex-data {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-flow: wrap;
		overflow-y: scroll;
	}

	.item-class img {
		width: 0.15rem;
		height: 0.15rem;
	}
.item-class span{
	margin-left:0.1rem;
	height: 0.15rem;
	line-height: 0.15rem;
}
	.item-class {
		cursor: pointer;
		margin: 0.1rem 0 0.1rem 0.2rem;
		font-size: 0.12rem;
		text-align: center;
		line-height: 0.3rem;
		border-radius: 0.05rem;
		color: #C0C0C0;
		border: 1px solid #C0C0C0;
		background-color: white;
		min-width: 1rem;
		height: 0.3rem;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}

	.select {
		color: #5599FF !important;
		border: 1px solid #5599FF !important;
	}
</style>
